import React from "react";
import { FormGroup, FormControl } from "react-bootstrap";

export default function ProductFilter(props) {
  const categoryItems = props.productCategories.map(
    ([label, children], index) => {
      return (
        <optgroup label={label} key={index}>
          {children.map(({ id, name }) => (
            <option value={id} key={name}>
              {name}
            </option>
          ))}
        </optgroup>
      );
    },
  );

  return (
    <FormGroup controlId="formControlsSelect">
      <FormControl
        componentClass="select"
        placeholder="Filter"
        value={props.selectedFilter}
        onChange={props.filterEvent}
      >
        <option value="">Alle Produkte anzeigen</option>
        {categoryItems}
      </FormControl>
    </FormGroup>
  );
}
